module.exports = __webpack_public_path__ + "img/6.967d18bf.jpg";